/**
 * Resolves image URLs to work in both development and production environments
 * 
 * In development: uploads are served from http://localhost:5006/uploads/
 * In production: nginx serves uploads directly from filesystem at /uploads/
 * 
 * @param {string} imageUrl - The image URL to resolve
 * @returns {string} - The resolved image URL
 */
export const resolveImageUrl = (imageUrl) => {
  if (!imageUrl || typeof imageUrl !== 'string') return '';
  
  // If it's already a full URL (https:// or http://), return as is
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    return imageUrl;
  }
  
  // Handle uploads directory - convert to data URL to bypass CORS in iframe
  if (imageUrl.startsWith('/uploads/')) {
    // For LivePreview iframe context, we need to proxy the image through the main app
    // to avoid CORS issues with the srcdoc iframe
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      // Development: use main app origin to proxy the image
      const proxyUrl = `/api/image-proxy?url=${encodeURIComponent(imageUrl)}`;
      return proxyUrl;
    }
    // Production: nginx serves uploads directly, return URL as-is
    return imageUrl;
  }
  
  // For other relative paths, return as is (fallback)
  return imageUrl;
};

/**
 * Helper to check if an image URL is valid (not empty)
 * @param {string} imageUrl 
 * @returns {boolean}
 */
export const isValidImageUrl = (imageUrl) => {
  return imageUrl && typeof imageUrl === 'string' && imageUrl.trim().length > 0;
};